/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import React from "react"
import { Link } from "trux"
import * as links from "../../util/links"
import { statHighlight } from "../../util/formatter"
import { Label, Avatar, format, Formats } from "trux"
import { PlayerStatsBaseballRow } from "./PlayerStatsBaseballRow"

// props
//  - playerStats
//  - playerStats.athlete
//  -teamName
//  -gameId
//  -eventNumber
function PlayerStatsRow({
    sportType,
    showStats,
    isTraceFamilyGame,
    isSensorless,
    isPanoramicSensorlessGame,
    ...props
}) {
    const ps = props.playerStats
    var playerUrl = links.gamePlayerDetailsUrl(
        props.teamName,
        props.playlistId,
        props.gameId,
        props.eventNumber,
        ps.athlete.id
    )

    let playerTitle =
        ps.athlete.jersey_number === ""
            ? `${format(ps.athlete, Formats.PlayerFullName)}`
            : `#${ps.athlete.jersey_number} ${format(
                  ps.athlete,
                  Formats.PlayerFullName
              )}`

    let nameCn = isPanoramicSensorlessGame
        ? "td name hide-xs touchable panoramic-sensorless"
        : "td name hide-xs touchable"

    return (
        <div
            className="tr"
            onClick={(e) => {
                if (props.playerStats.no_data) {
                    return
                }
                e.preventDefault()
                props.history.push(playerUrl)
            }}
        >
            <div className="td avatar">
                <Link data-trk-act="Player Pressed" to={playerUrl}>
                    <Avatar
                        fullName={format(ps.athlete, Formats.PlayerFullName)}
                        initials={format(ps.athlete, Formats.PlayerAbbr)}
                        imageUrl={`https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/avatars?user=${ps.athlete.user.user_id}`}
                        size={40}
                    />
                </Link>
            </div>
            <div className={nameCn}>
                <Label type={Label.Type.Body} bold>
                    <Link className="text-black-color" to={playerUrl}>
                        {playerTitle}
                    </Link>
                </Label>
            </div>
            {!ps.no_data && sportType === "soccer" && (
                <div className="td stat stat-effort">
                    <span
                        className={statHighlight(
                            ps.effort_rank,
                            props.playerCount,
                            !isTraceFamilyGame
                        )}
                    >
                        {ps.effort_formatted}
                    </span>
                </div>
            )}
            {!ps.no_data && sportType === "soccer" && (
                <div className="td stat stat-stamina">
                    <span
                        className={statHighlight(
                            ps.stamina_rank,
                            props.playerCount,
                            !isTraceFamilyGame
                        )}
                    >
                        {ps.stamina_formatted}
                    </span>
                </div>
            )}
            {!ps.no_data && sportType === "soccer" && (
                <div className="td stat stat-distance">
                    <span
                        className={statHighlight(
                            ps.distance_rank,
                            props.playerCount,
                            !isTraceFamilyGame
                        )}
                    >
                        {ps.distance_formatted}
                    </span>
                </div>
            )}
            {!ps.no_data && sportType === "soccer" && (
                <div className="td stat stat-speed">
                    <span
                        className={statHighlight(
                            ps.top_speed_rank,
                            props.playerCount,
                            !isTraceFamilyGame
                        )}
                    >
                        {ps.top_speed_formatted}
                    </span>
                </div>
            )}
            {!ps.no_data && sportType === "baseball" && (
                <PlayerStatsBaseballRow
                    stats={ps}
                    playerCount={props.playerCount}
                    isTraceFamilyGame={isTraceFamilyGame}
                />
            )}

            {!ps.no_data && sportType === "soccer" && showStats && (
                <div className="td stat stat-minutes">
                    {ps.minutes_formatted}
                </div>
            )}
            {ps.no_data && !isTraceFamilyGame && !isPanoramicSensorlessGame && (
                <div className="td nodata">
                    <a
                        data-trk-act="Help Pressed"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://traceup.com/soccer/help/sensorless-game-results"
                    >
                        We couldn&apos;t identify you
                    </a>{" "}
                    🙁
                </div>
            )}
        </div>
    )
}

export default PlayerStatsRow
